import { action, thunk } from 'easy-peasy';
import * as diagnosisCodesService from '../../services/diagnosisCodes';

var tempList = [];
const diagnosisCodesModel = {
  isLoader: false,
  isAllDiagnosisCodesLoaded: false,
  diagnosisCodesList: [],
  diagnosisCodes: {},
  // SET DAIGNOSISCADES LOADER
  setDiagnosisCodesLoader: action((state, payload) => {
    state.isLoader = payload;
  }),
  // IS ALL DATA LOADED
  setIsAllDiagnosisCodesLoaded: action((state, payload) => {
    state.isAllDiagnosisCodesLoaded = payload;
  }),
  // SET DAIGNOSISCADES DATA
  setDiagnosisCodesList: action((state, payload) => {
    state.diagnosisCodesList = payload;
  }),
  setDiagnosisCodes: action((state, payload) => {
    state.diagnosisCodes = payload;
  }),

  getDiagnosisCodesList: thunk(async (actions, payload) => {
    if (!payload || !payload.next_page) {
      actions.setDiagnosisCodesLoader(true);
      actions.setIsAllDiagnosisCodesLoaded(false);
      tempList = [];
    }
    return await diagnosisCodesService.getDiagnosisCodesList(payload)
      .then(function (response) {
        if (response.data) {
          actions.setDiagnosisCodesLoader(false);
          tempList = tempList.concat(response.data.data.items);
          actions.setDiagnosisCodesList(tempList);
        }
        if (response.data && response.data.data && response.data.data.pagination && response.data.data.pagination.next_page) {
          payload = {
            next_page: response.data.data.pagination.next_page,
          };
          actions.getDiagnosisCodesList(payload);
        } else {
          actions.setIsAllDiagnosisCodesLoaded(true);
        }
        return response;
      })
      .catch(function (error) {
        return error;
      });
  }),
  getDiagnosisCodes: thunk(async (actions, payload) => {
    const response = await diagnosisCodesService.getDiagnosisCodes(payload);
    if (response) {
      actions.setDiagnosisCodes(response.data.data);
      return response.data.data;
    }
  }),
  addDiagnosisCodes: thunk(async (actions, payload) => {
    const response = await diagnosisCodesService.addDiagnosisCodes(payload);
    return response;
  }),
  updateDiagnosisCodes: thunk(async (actions, payload) => {
    const response = await diagnosisCodesService.updateDiagnosisCodes(payload);
    return response;
  }),
  updateDiagnosisCodeStatus: thunk(async (actions, payload) => {
    return await diagnosisCodesService.updateDiagnosisCodeStatus(payload);
  }),
};

export default diagnosisCodesModel;
